var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M8.93967 0.0352173V8.08192H0.780357V3.43959C0.937267 1.58266 2.50637 0.0352173 4.38928 0.0352173H8.93967Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M8.93967 9.7841V17.8308H4.23237C2.34945 17.8308 0.780354 16.2834 0.780354 14.4264V9.7841H8.93967Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M18.825 9.7841V14.4264C18.825 16.2834 17.2559 17.8308 15.373 17.8308H10.6657V9.7841H18.825Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M18.825 3.43959V8.08192H10.6657V0.0352173H15.373C17.2559 0.0352173 18.825 1.58266 18.825 3.43959Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolders);
export default __webpack_public_path__ + "static/media/folders.541a0309e99b361856f56ff194b2bd4c.svg";
export { ForwardRef as ReactComponent };